import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';

interface Props<T> extends React.PropsWithChildren<LinkProps> {
  state?: T;
}

export function InternalLink<T = unknown>(props: Props<T>) {
  return (
    <span
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (props.onClick) {
          props.onClick(event);
        }
      }}
    >
      <Link {...props} />
    </span>
  );
}
